import { UsersFilterName } from 'services/specialist';
import {
  ClinicalAssessmentResult,
  DischargeReason,
  LinkReason,
} from 'services/user';

import * as types from 'components/TCDashboardTab/types';

export interface PatientInfo {
  cognitoId?: string;
  fullName?: string;
  linkedAt?: string;
  phqValue?: number;
  gadValue?: number;
  unlinkedAt?: string;
  reason?: LinkReason;
  lastMessage?: string;
  lastActivity?: string;
  therapistName?: string;
  doneActivities?: number;
  totalActivities?: number;
  doneActivitiesRatio?: number;
  dischargeReason?: DischargeReason;
  phqResult?: ClinicalAssessmentResult;
  gadResult?: ClinicalAssessmentResult;
}

export type TableDataKeys = keyof PatientInfo;

export interface TCDashboardTableData {
  name: string;
  data?: PatientInfo[];
}

export const tabNameToUsersFilterName = (tabName: types.TabName) => {
  const indexOfS = Object.values(types.TabName).indexOf(
    tabName as types.TabName,
  );

  const key = Object.keys(types.TabName)[
    indexOfS
  ] as keyof typeof UsersFilterName;

  return UsersFilterName[key];
};
